import * as HttpStatus from 'http-status-codes'

import { HttpError } from '@webapp/infrastructure/interfaces/services/IHttpClient'

/**
 * A 401 whose body says the session is gone. Extends `HttpError` so the
 * `IHttpClient` contract (every rejection is an `HttpError` with status and
 * headers) still holds for repositories that branch on it. `response` is the
 * response body on every client. The name and message are what Sentry's
 * `ignoreErrors` entry matches on.
 */
export class APISessionExpiredError<T = unknown> extends HttpError<T> {
  name = 'APISessionExpiredError'

  constructor(
    message: string,
    response: Nullable<T>,
    headers?: Record<string, string | undefined>
  ) {
    super(HttpStatus.UNAUTHORIZED, response, headers)
    this.message = message
  }
}
